import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const environment = (import.meta.env.VITE_APP_ENV as string | undefined) || 'dev';
const release = (import.meta.env.VITE_APP_VERSION as string | undefined) || 'dev';

if (dsn) {
  Sentry.init({
    dsn,
    // Tunnel events through our own /api/sentry-tunnel so:
    //  1. Browsers don't see a cross-origin public→private request (Chrome's
    //     Local Network Access prompt on VPN-split-DNS setups), and
    //  2. Common adblockers (which block direct sentry.io/ingest requests)
    //     don't suppress events.
    tunnel: '/api/sentry-tunnel',
    environment,
    release,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Privacy-first: this is an internal admin tool handling entrant PII
      // (names, emails, contact + project details). Mask all text and block
      // media in replayed DOM content (NOC-389). Inputs are masked by default;
      // layout and interaction flow are still recorded, so replays remain
      // useful for debugging. This does NOT scrub URLs: the account-setup and
      // password-reset routes carry `userId` / `code` query params, which a
      // replay's recorded URL still contains — those need separate scrubbing.
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: environment === 'prod' ? 0.1 : 1.0,
    replaysSessionSampleRate: environment === 'prod' ? 0.1 : 0.0,
    replaysOnErrorSampleRate: 1.0,
    beforeSendTransaction(event) {
      // Drop noisy health-check traces
      if (event.transaction === 'GET /api/health') return null;
      return event;
    },
  });
}

export { Sentry };
